  <h2 mat-dialog-title class="dialog-title">
    <mat-icon>event</mat-icon>
    Events for {{ data.day.date | date : "fullDate" }}
  </h2>

  <mat-dialog-content>
    <div *ngIf="data.day.events.length === 0" class="no-events">
      <mat-icon>info</mat-icon>
      <p>No events scheduled for this day</p>
    </div>

    <mat-list *ngIf="data.day.events.length > 0">
      <mat-list-item *ngFor="let event of data.day.events" class="event-item">
        <div matListItemIcon>
          <mat-icon [style.color]="event.color?.primary">circle</mat-icon>
        </div>
        <div matListItemTitle>{{ event.title }}</div>
        <div matListItemLine>
          {{ event.start | date : "shortTime" }}
          <span *ngIf="event.end"> - {{ event.end | date : "shortTime" }}</span>
        </div>
      </mat-list-item>
    </mat-list>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-button mat-dialog-close>
      <mat-icon>close</mat-icon>
      Close
    </button>
  </mat-dialog-actions>